import axios from "axios"
import React, { useContext, useEffect, useState } from "react"
import {
  Card,
  CardBody,
  ModalHeader,
  Row,
  Col,
  Input,
  Button,
  Form,
  Label,
  FormGroup,
} from "reactstrap"
import { DataContext } from "../../context/dataContext"

import apiHandler from "../../common/config/apiHandler"

import { useStripe, useElements } from "@stripe/react-stripe-js"
import { loadStripe } from "@stripe/stripe-js"
import toast from "react-hot-toast"
import createIntent from "../../common/config/createIntent"
import DatePicker from "react-datepicker"

// const stripePromise = loadStripe(
//   "pk_test_51O5n1NIZoVVoxbvq3pVxPmekEYjHhKQEIBlToIfXMPpCdSoVuLzsZNxGMmcGZYepEEDZeZVstQDq2emOGoQqFiFW00csG393Up"
// )

const EditCustomerDetails = ({
  bookingDetails,
  combinedData,
  setCombinedData,
  handleCombinedChange,
  setApiTag,
  apiTag,
  setExtraCharges,
  setActiveTab,
}) => {
  const [subscribeKey, setSubscribeKey] = useState("")
  const [clientSecret, setClient_Secret] = useState("")
  const { token, fetchSubscribeKey } = useContext(DataContext)

  const [payment_intent, setPayment_Intent] = useState("")

  const [loadingPayment, setLoadingPayment] = useState(false)
  useEffect(() => {
    const currentDetail = bookingDetails?.bookingDetails?.find(
      detail => detail?.is_current === true || detail?.is_current === 1
    )

    if (currentDetail) {
      setCombinedData(prevState => ({
        ...prevState,
        site_id: String(bookingDetails?.site_id),
        reference_no: bookingDetails?.reference_no,
        title: currentDetail.customer.title || "",
        first_name: currentDetail?.customer?.first_name || "",
        last_name: currentDetail?.customer?.last_name || "",
        email: currentDetail.customer.email || "",
        contact_no: currentDetail.customer.contact_no || "",
        make: currentDetail?.vehicle.make == "0" ? "TBC" : currentDetail?.vehicle.make || "",
        model: currentDetail?.vehicle.model == "0" ? "TBC" :  currentDetail?.vehicle.model || "",
        color: currentDetail?.vehicle.color == "0" ? "TBC" : currentDetail?.vehicle.color || "",
        reg_no: currentDetail?.vehicle.reg_no == "0" ? "TBC" :  currentDetail?.vehicle.reg_no || "",
        departure_time: currentDetail?.departure_time || "",
        arrival_time: currentDetail?.arrival_time || "",
        departure_terminal: currentDetail?.departure_terminal || "",
        departure_flight_no: currentDetail?.departure_flight_no || "",
        arrival_terminal: currentDetail?.arrival_terminal || "",
        arrival_flight_no: currentDetail?.arrival_flight_no || "",
        no_of_peoples: String(currentDetail?.no_of_peoples) || "",
      }))
      setExtraCharges(bookingDetails?.site?.amend_charge)
      setApiTag(currentDetail?.company?.sku_tag)
    }
  }, [bookingDetails])

  useEffect(() => {
    if (combinedData) {
      fetchSubscribeKey(apiTag, bookingDetails?.site_id)
    }
  }, [combinedData])


  return (
    <>
      {bookingDetails?.bookingDetails
        ?.filter(
          detail => detail?.is_current === true || detail?.is_current === 1
        )
        ?.map((detail, index) => (
          <Card>
            <CardBody>
              <div>
                <h6 style={{ fontWeight: "600" }}> Edit Customer Details</h6>
              </div>
              <Form>
                <Row className="mt-3">
                  <Col md={6}>
                    <label>First Name:</label>
                    <Input
                      type="text"
                      name="first_name"
                      className="form-control mb-3 form-input"
                      placeholder="Enter First Name"
                      style={{ fontSize: "11px" }}
                      value={combinedData?.first_name}
                      onChange={handleCombinedChange}
                    />
                  </Col>
                  <Col md={6}>
                    <label>Last Name:</label>
                    <Input
                      type="text"
                      name="last_name"
                      className="form-control mb-3 form-input"
                      placeholder="Enter Last Name"
                      style={{ fontSize: "11px" }}
                      value={combinedData?.last_name}
                      onChange={handleCombinedChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <label>Contact:</label>
                    <Input
                      type="text"
                      name="contact_no"
                      className="form-control mb-3 form-input"
                      placeholder="Enter Contact"
                      style={{ fontSize: "11px" }}
                      value={combinedData?.contact_no}
                      onChange={handleCombinedChange}
                    />
                  </Col>
                  <Col md={6}>
                    <label>Email Address:</label>
                    <Input
                      type="email"
                      name="email"
                      className="form-control mb-3 form-input"
                      placeholder="Enter Email Address"
                      style={{ fontSize: "11px" }}
                      value={combinedData?.email}
                      onChange={handleCombinedChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <label for="departTime" style={{ fontSize: "11px" }}>
                        Depart Time *
                      </label>
                      <DatePicker
                        selected={
                          combinedData?.departure_time
                            ? new Date(
                                `1970-01-01T${combinedData?.departure_time}`
                              )
                            : null
                        }
                        onChange={time =>
                          handleCombinedChange({
                            target: {
                              name: "departure_time",
                              value: time.toTimeString().slice(0, 5),
                            },
                          })
                        }
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeFormat="HH:mm"
                        dateFormat="HH:mm"
                        className="form-input f-11"
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <label for="arrivalTime" style={{ fontSize: "11px" }}>
                        Arrival Time *
                      </label>
                      <DatePicker
                        selected={
                          combinedData?.arrival_time
                            ? new Date(
                                `1970-01-01T${combinedData?.arrival_time}`
                              )
                            : null
                        }
                        onChange={time =>
                          handleCombinedChange({
                            target: {
                              name: "arrival_time",
                              value: time.toTimeString().slice(0, 5),
                            },
                          })
                        }
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeFormat="HH:mm"
                        dateFormat="HH:mm"
                        className="form-input f-11"
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <label for="departTerminal" style={{ fontSize: "11px" }}>
                        Depart Terminal *
                      </label>
                      <Input
                        type="select"
                        name="departure_terminal"
                        id="departTerminal"
                        value={combinedData?.departure_terminal}
                        onChange={handleCombinedChange}
                        style={{ fontSize: "11px" }}
                        className="form-input"
                      >
                        {detail?.airport.terminal.map(terminal => (
                          <option key={terminal.id} value={terminal.name}>
                            {terminal.name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <label for="departFlight" style={{ fontSize: "11px" }}>
                        Depart Flight *
                      </label>
                      <Input
                        className="form-input"
                        type="text"
                        name="departure_flight_no"
                        id="departFlight"
                        value={combinedData?.departure_flight_no}
                        onChange={handleCombinedChange}
                        style={{ fontSize: "11px" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <label for="returnTerminal" style={{ fontSize: "11px" }}>
                        Return Terminal *
                      </label>
                      <Input
                        className="form-input"
                        type="select"
                        name="arrival_terminal"
                        id="returnTerminal"
                        value={combinedData?.arrival_terminal}
                        onChange={handleCombinedChange}
                        style={{ fontSize: "11px" }}
                      >
                        {detail?.airport.terminal.map(terminal => (
                          <option key={terminal.id} value={terminal.name}>
                            {terminal.name}
                          </option>
                        ))}
                      </Input>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <label for="arrivalFlight" style={{ fontSize: "11px" }}>
                        Arrival Flight *
                      </label>
                      <Input
                        className="form-input"
                        type="text"
                        name="arrival_flight_no"
                        id="arrivalFlight"
                        value={combinedData?.arrival_flight_no}
                        onChange={handleCombinedChange}
                        style={{ fontSize: "11px" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <label for="make" style={{ fontSize: "11px" }}>
                        Make *
                      </label>
                      <Input
                        className="form-input"
                        type="text"
                        name="make"
                        id="make"
                        value={combinedData?.make }
                        onChange={handleCombinedChange}
                        style={{ fontSize: "11px" }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <label for="model" style={{ fontSize: "11px" }}>
                        Model *
                      </label>
                      <Input
                        className="form-input"
                        type="text"
                        name="model"
                        id="model"
                        value={combinedData?.model }
                        onChange={handleCombinedChange}
                        style={{ fontSize: "11px" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormGroup>
                      <label for="color" style={{ fontSize: "11px" }}>
                        Color *
                      </label>
                      <Input
                        className="form-input"
                        type="text"
                        name="color"
                        id="color"
                        value={combinedData?.color}
                        onChange={handleCombinedChange}
                        style={{ fontSize: "11px" }}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup>
                      <label for="registration" style={{ fontSize: "11px" }}>
                        Registration *
                      </label>
                      <Input
                        className="form-input"
                        type="text"
                        name="reg_no"
                        id="registration"
                        value={combinedData?.reg_no}
                        onChange={handleCombinedChange}
                        style={{ fontSize: "11px" }}
                      />
                    </FormGroup>
                  </Col>
                </Row>
                {bookingDetails?.bookingDetails[0]?.company?.type_id == 1 ? (
                  ""
                ) : (
                  <FormGroup>
                    <label for="noOfPassengers" style={{ fontSize: "11px" }}>
                      No of Passengers *
                    </label>
                    <Input
                      className="form-input"
                      type="number"
                      name="no_of_peoples"
                      id="noOfPassengers"
                      value={combinedData?.no_of_peoples}
                      onChange={handleCombinedChange}
                      style={{ fontSize: "11px" }}
                      min="0"
                    />
                  </FormGroup>
                )}

                <Row>
                  <Col md={6}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          className="border-primary"
                          name="customer_email"
                          checked={combinedData?.customer_email == "1" ? true : false}
                          onClick={handleCombinedChange}
                          style={{ fontSize: "11px" }}
                        />{" "}
                        Send Customer Email
                      </Label>
                    </FormGroup>
                  </Col>
                  <Col md={6}>
                    <FormGroup check>
                      <Label check>
                        <Input
                          type="checkbox"
                          className="border-primary"
                          name="company_email"
                          checked={
                            combinedData?.company_email == "1" ? true : false
                          }
                          onClick={handleCombinedChange}
                          style={{ fontSize: "11px" }}
                        />{" "}
                        Send Company Email
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>

                <Button
                  color="secondary"
                  size="sm"
                  onClick={() => setActiveTab("")}
                >
                  Close
                </Button>
              </Form>
            </CardBody>
          </Card>
        ))}
    </>
  )
}

export default EditCustomerDetails
